export const setItem = (key, value) => {
  try {
    globalThis.localStorage.setItem(key, value);
  } catch {
    // Storage may be unavailable; callers do not require persistence to succeed.
  }
};

export const getItem = key => {
  try {
    return globalThis.localStorage.getItem(key) || null;
  } catch {
    // Storage may be unavailable; return the same value as a missing key.
    return null;
  }
};

export const removeItem = key => {
  try {
    globalThis.localStorage.removeItem(key);
  } catch {
    // Storage may be unavailable; callers do not require removal to succeed.
  }
};

export const setJsonItem = (key, value) => {
  setItem(key, JSON.stringify(value));
};

export const getJsonItem = key => {
  return JSON.parse(getItem(key));
};
